import { c as _c } from "react/compiler-runtime";
import { Button, Field, Input, InputGroup, Text, VStack } from '@chakra-ui/react';
import { ClipboardIconButton, ClipboardInput, ClipboardRoot } from '@src/components/chakra-ui/clipboard';
import { LuSave } from 'react-icons/lu';
export type ProfileLinksEditorProps = {
  profileUrl: string | null;
  bookUrl: string;
  complimentaryUrl: string;
  waiveCode: string;
  waiveInvalid: boolean;
  error: string | null;
  saved: boolean;
  saving: boolean;
  onWaiveCodeChange: (value: string) => void;
  onSave: () => void;
};
const LinkRow = t0 => {
  const $ = _c(10);
  const {
    label,
    description,
    url
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <Field.Label>{label}</Field.Label>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== url) {
    t2 = url ? <ClipboardRoot value={url} width="full"><InputGroup endElement={<ClipboardIconButton />} width="full"><ClipboardInput readOnly={true} /></InputGroup></ClipboardRoot> : <Input disabled={true} placeholder="Your public profile slug is not set yet" />;
    $[2] = url;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = <Field.HelperText>{description}</Field.HelperText>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <Field.Root>{t1}{t2}{t3}</Field.Root>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export const ProfileLinksEditor = t0 => {
  const $ = _c(44);
  const {
    profileUrl,
    bookUrl,
    complimentaryUrl,
    waiveCode,
    waiveInvalid,
    error,
    saved,
    saving,
    onWaiveCodeChange,
    onSave
  } = t0;
  let t1;
  if ($[0] !== profileUrl) {
    t1 = <LinkRow description="Anyone can open your member profile from this address." label="Profile" url={profileUrl} />;
    $[0] = profileUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== bookUrl) {
    t2 = <LinkRow description="Opens your member profile with booking on the page. Guests register there." label="Book a session" url={bookUrl} />;
    $[2] = bookUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Field.Label>Complimentary coupon</Field.Label>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onWaiveCodeChange) {
    t4 = event => onWaiveCodeChange(event.currentTarget.value);
    $[5] = onWaiveCodeChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4 || $[8] !== waiveCode) {
    t5 = <Input maxLength={32} placeholder="friends-2026" value={waiveCode} onChange={t4} />;
    $[7] = t4;
    $[8] = waiveCode;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Field.HelperText>Letters, numbers, and hyphens. This segment of the link acts like a coupon: anyone who books with it skips session fees.</Field.HelperText>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== waiveInvalid) {
    t7 = waiveInvalid ? <Field.ErrorText>Use 3–32 characters: lowercase letters, numbers, hyphens.</Field.ErrorText> : null;
    $[11] = waiveInvalid;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7 || $[15] !== waiveInvalid) {
    t8 = <Field.Root invalid={waiveInvalid}>{t3}{t5}{t6}{t7}</Field.Root>;
    $[13] = t5;
    $[14] = t7;
    $[15] = waiveInvalid;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Field.Label>Complimentary booking</Field.Label>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ClipboardIconButton />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <InputGroup endElement={t10} width="full"><ClipboardInput readOnly={true} /></InputGroup>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== complimentaryUrl) {
    t12 = <ClipboardRoot value={complimentaryUrl} width="full">{t11}</ClipboardRoot>;
    $[20] = complimentaryUrl;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Field.HelperText>Save the coupon before you share this link so it will honor the code.</Field.HelperText>;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12) {
    t14 = <Field.Root>{t9}{t12}{t13}</Field.Root>;
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14 || $[26] !== t8) {
    t15 = <VStack align="stretch" gap={4}>{t8}{t14}</VStack>;
    $[25] = t14;
    $[26] = t8;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== error) {
    t16 = error ? <Text color="red.fg" fontFamily="longform" fontSize="sm">{error}</Text> : null;
    $[28] = error;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== saved) {
    t17 = saved ? <Text color="green.fg" fontFamily="longform" fontSize="sm">Complimentary link saved.</Text> : null;
    $[30] = saved;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <LuSave />;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== onSave || $[34] !== saving || $[35] !== waiveInvalid) {
    t19 = <Button alignSelf="flex-start" disabled={waiveInvalid} loading={saving} variant="cta" onClick={onSave}>{t18} Save complimentary link</Button>;
    $[33] = onSave;
    $[34] = saving;
    $[35] = waiveInvalid;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t1 || $[38] !== t15 || $[39] !== t16 || $[40] !== t17 || $[41] !== t19 || $[42] !== t2) {
    t20 = <VStack align="stretch" gap={6}>{t1}{t2}{t15}{t16}{t17}{t19}</VStack>;
    $[37] = t1;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
    $[41] = t19;
    $[42] = t2;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
};